'use client';

import { BASE_URL } from '@storefront/utils/constants';

export const saveCurrentProductConfigurationURL = (urlTo: string): void => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(
      'currentProductConfigurationURL',
      urlTo.startsWith(BASE_URL) ? urlTo.replace(BASE_URL, '') : urlTo
    );
  }
};

export const getCurrentProductConfigurationURL = (): string | null => {
  const allowedPaths = ['/pdp-config'];
  if (typeof localStorage !== 'undefined') {
    const path = localStorage.getItem('currentProductConfigurationURL') || '';
    const isValidConfig = /^([a-zA-Z0-9\-_.?=&%/]+)$/.test(path);
    const hasTraversal = path.includes('..');
    const isAllowedPath = allowedPaths.some((allowedPath) =>
      path.startsWith(allowedPath)
    );

    if (isValidConfig && !hasTraversal && isAllowedPath) return path;
    console.error('Invalid product configuration URL.', path);
  }
  return null;
};

export const saveAemCallbackURL = (url: string): void => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('aemCallbackURL', url);
  }
};

export const getAemCallbackURL = (): string | null => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem('aemCallbackURL');
  }
  return null;
};

export const getFallbackURL = (): string =>
  'https://www.hp.com/us-en/home.html';
